import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

import { InfoCard, InfoCardRowDef } from '~components';

import PoliciesService from '../../services/policyService';

const service = new PoliciesService();

interface PolicyGeneralInfoCardProps {
	id?: string;
}

const PolicyGeneralInfoCard = ({ id }: PolicyGeneralInfoCardProps) => {
	const { t } = useTranslation();

	const { data, isLoading, error } = useSWR(id != null && [service.basePath, id], ([_, id]) =>
		service.getPolicyById(id)
	);

	const rows: InfoCardRowDef[] | undefined =
		data != null ?
			[
				{
					headerName: t('ui.label.name'),
					value: data.label,
				},
				{
					headerName: t('ui.label.organisation'),
					value: data.organisation.label,
				},
			]
		:	undefined;

	return (
		<InfoCard
			title={t('views.policyDetail.summary.cardHeaders.general')}
			rows={rows ?? []}
			error={error != null}
			loading={isLoading}
		/>
	);
};

export default PolicyGeneralInfoCard;
